import { Controller } from 'stimulus'
import throttle from 'lodash/throttle'

export default class extends Controller {

  connect() {
    this.state = {
      tolerance: 64,
      expanded: false,
      disabled: false,
      scrollTarget: 0
    }
    
    this.setScrollTarget()
    this.checkScrollPosition()
    document.addEventListener('scroll', throttle(this.checkScrollPosition.bind(this)))
    document.addEventListener('resize', throttle(this.setScrollTarget.bind(this)))
  }

  disconnect() {
    document.removeEventListener('scroll', throttle(this.handleResize, 250))
  }

  setScrollTarget() {
    let viewportHeight = window.outerHeight
    let documentOffset = ((document.documentElement.scrollHeight / 4) * 3)
    this.state.scrollTarget = Math.round(documentOffset - viewportHeight)
  }

  checkScrollPosition() {
    if (!this.state.disabled) {
      let currentPosition = window.scrollY
      if (currentPosition >= this.state.scrollTarget && !this.state.expanded && !this.state.disabled) {
        this.toggle()
        this.lazyloadAssets()
      } else if (currentPosition <= this.state.scrollTarget && this.state.expanded) {
        this.toggle()
      }
    }
  }

  dismiss() {
    this.element.setAttribute('aria-expanded', 'false')
    this.state.disabled = true
    this.state.expanded = false
  }

  lazyloadAssets() {
    setTimeout(()=>
      window.scroll()
    , 250)
  }

  toggle() {
    this.element.setAttribute('aria-expanded', !this.state.expanded)
    this.state.expanded = !this.state.expanded
  }
}